// extracted by mini-css-extract-plugin
module.exports = {"navHeight":"4.5rem","title":"payment_title__U83dl","container":"payment_container__1uSbp"};